import { render, staticRenderFns } from "./Adddept.vue?vue&type=template&id=3b38abed&scoped=true"
import script from "./Adddept.vue?vue&type=script&lang=js"
export * from "./Adddept.vue?vue&type=script&lang=js"
import style0 from "./Adddept.vue?vue&type=style&index=0&id=3b38abed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b38abed",
  null
  
)

export default component.exports